import clsx from 'clsx';

export function Divider({
  soft = false,
  className,
  ...props
}: { soft?: boolean } & React.ComponentPropsWithoutRef<'hr'>) {
  return (
    <hr
      role="presentation"
      {...props}
      className={clsx(
        className,
        'tw:w-full tw:border-t',
        soft && 'tw:border-zinc-950/5 tw:dark:border-white/5',
        !soft && 'tw:border-zinc-950/10 tw:dark:border-white/10'
      )}
    />
  );
}
